<div class="list-container">
    <rask-list [data]="kundordrar" [getSelectedFromRoute]="true">
        <rask-list-column header="{{ 'KUNDORDER_LIST_KUND' | translate }}" field="kund" [sortable]="true"
            [nowrap]="true" width="300px">
            <ng-template let-row="row">
                <a [routerLink]="row.id">
                    <span data-bs-toggle="tooltip" data-placement="top" title="{{row.kund}}">
                        {{row.kund}}
                    </span>
                </a>
            </ng-template>
        </rask-list-column>
        <rask-list-column header="{{ 'KUNDORDER_LIST_PERIODFROM' | translate }}" field="periodFrom" [sortable]="true"
            [nowrap]="true" width="110px"></rask-list-column>
        <rask-list-column header="{{ 'KUNDORDER_LIST_PERIODTOM' | translate }}" field="periodTom" [sortable]="true"
            [nowrap]="true" width="100px"></rask-list-column>
        <rask-list-column header="{{ 'KUNDORDER_LIST_ORDERNUMMER' | translate }}" field="ordernummer" [sortable]="true"
            [nowrap]="true" width="120px"></rask-list-column>
        <rask-list-column header="{{ 'KUNDORDER_LIST_MOTTAGNINGSPLATS' | translate }}" field="mottagningsplats"
            [sortable]="true" [nowrap]="true" [tooltip]="true"></rask-list-column>
        <rask-list-column header="{{ 'KUNDORDER_LIST_HANDELSSORTIMENT' | translate }}" field="handelssortiment"
            [sortable]="true" [nowrap]="true" [tooltip]="true"></rask-list-column>
        <rask-list-column header="{{ 'KUNDORDER_LIST_KVANTITET' | translate }}" field="kvantitet" [sortable]="true"
            [nowrap]="true"></rask-list-column>
        <rask-list-column header="{{ 'KUNDORDER_LIST_AVTALSANSVARIG' | translate }}" field="avtalsansvarig"
            [sortable]="true" [nowrap]="true"></rask-list-column>
        <rask-list-column header="{{ 'KUNDORDER_LIST_BESKRIVNING' | translate }}" field="beskrivning" [sortable]="true"
            [nowrap]="true" [tooltip]="true" width="20%">
        </rask-list-column>
    </rask-list>
</div>